module.exports = __webpack_public_path__ + "static/media/reupload-permitted.01201a29.svg";